import { Permissions } from "../permissions";

export const OwnerRolePermissions = [...Permissions];